import {
    WindowShapeId,
    WindowLeafShapeId,
} from '@core/constants/Shape';
import { MaterialId } from '@core/constants/Material';
import { FieldDimensionId } from '@core/constants/FieldDimension';
import { WindowGlazingId, WindowInsulationId, WindowOpeningSideId } from '@core/constants/Option';
import {
    IFormFieldShape,
    IFormFieldMaterial,
    IFormInputType,
    IDimensionUnit,
    IFormFieldShapeDimension,
    IFormFieldRadioList,
} from '../../../interfaces/Form';
import {
    allMetals,
    allPlastics,
    allSolidWoods,
    getMaterialsWithExceptions,
} from './materialGroups';

export const fieldsWindowShapeDimension: IFormFieldShapeDimension = {
    shape: {
        value   : undefined,
        options : [
            WindowShapeId.SingleWindow,
            WindowShapeId.WindowBay,
            WindowShapeId.WindowCorner,
            WindowShapeId.WindowDiamond,
            WindowShapeId.WindowElbow,
            WindowShapeId.WindowLowered,
            WindowShapeId.WindowPointedTrapezoidal,
            WindowShapeId.WindowRound,
            WindowShapeId.WindowSemicircular,
            WindowShapeId.WindowTrapezoidal,
            WindowShapeId.WindowTrapezoidalWithShell,
            WindowShapeId.WindowTriangle,
        ],
        required: true,
    },
    dimension: {
        options: {
            [WindowShapeId.SingleWindow]: {
                [FieldDimensionId.Width]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 10,
                    range        : { min: 300, max: 3000 },
                    required     : true,
                    defaultValue : 1000,
                },
                [FieldDimensionId.Height]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 10,
                    range        : { min: 300, max: 2500 },
                    required     : true,
                    defaultValue : 500,
                },
            },
            [WindowShapeId.WindowBay]: {
                [FieldDimensionId.Diagonal1]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 10,
                    range        : { min: 300, max: 3000 },
                    required     : true,
                    defaultValue : 1000,
                },
                [FieldDimensionId.Width2]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 10,
                    range        : { min: 300, max: 3000 },
                    required     : true,
                    defaultValue : 1000,
                },
                [FieldDimensionId.Height3]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 10,
                    range        : { min: 300, max: 2500 },
                    required     : true,
                    defaultValue : 500,
                },
                [FieldDimensionId.Width4]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 10,
                    range        : { min: 300, max: 2500 },
                    required     : true,
                    defaultValue : 500,
                },
            },
            [WindowShapeId.WindowCorner]: {
                [FieldDimensionId.Diagonal1]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 10,
                    range        : { min: 300, max: 3000 },
                    required     : true,
                    defaultValue : 1000,
                },
                [FieldDimensionId.Height2]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 10,
                    range        : { min: 300, max: 2500 },
                    required     : true,
                    defaultValue : 500,
                },
                [FieldDimensionId.Width3]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 10,
                    range        : { min: 200, max: 1800 },
                    required     : true,
                    defaultValue : 900,
                },
            },
            [WindowShapeId.WindowDiamond]: {
                [FieldDimensionId.Width]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 10,
                    range        : { min: 300, max: 3000 },
                    required     : true,
                    defaultValue : 1000,
                },
            },
            [WindowShapeId.WindowElbow]: {
                [FieldDimensionId.Width]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 10,
                    range        : { min: 300, max: 3000 },
                    required     : true,
                    defaultValue : 1000,
                },
                [FieldDimensionId.Height]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 10,
                    range        : { min: 300, max: 2500 },
                    required     : true,
                    defaultValue : 500,
                },
            },
            [WindowShapeId.WindowLowered]: {
                [FieldDimensionId.Width]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 10,
                    range        : { min: 300, max: 3000 },
                    required     : true,
                    defaultValue : 1000,
                },
                [FieldDimensionId.Height]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 10,
                    range        : { min: 300, max: 2500 },
                    required     : true,
                    defaultValue : 500,
                },
            },
            [WindowShapeId.WindowPointedTrapezoidal]: {
                [FieldDimensionId.Diagonal1]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 10,
                    range        : { min: 300, max: 3000 },
                    required     : true,
                    defaultValue : 1000,
                },
                [FieldDimensionId.Height2]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 10,
                    range        : { min: 300, max: 2500 },
                    required     : true,
                    defaultValue : 500,
                },
                [FieldDimensionId.Width3]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 10,
                    range        : { min: 300, max: 2500 },
                    required     : true,
                    defaultValue : 500,
                },
                [FieldDimensionId.Height4]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 2,
                    range        : { min: 14, max: 28 },
                    required     : true,
                    defaultValue : 18,
                },
            },
            [WindowShapeId.WindowRound]: {
                [FieldDimensionId.Radius]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 10,
                    range        : { min: 800, max: 3000 },
                    required     : true,
                    defaultValue : 2000,
                },
            },
            [WindowShapeId.WindowSemicircular]: {
                [FieldDimensionId.Width]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 10,
                    range        : { min: 300, max: 3000 },
                    required     : true,
                    defaultValue : 1000,
                },
                [FieldDimensionId.Height]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 10,
                    range        : { min: 300, max: 2500 },
                    required     : true,
                    defaultValue : 500,
                },
            },
            [WindowShapeId.WindowTrapezoidal]: {
                [FieldDimensionId.Width1]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 10,
                    range        : { min: 300, max: 3000 },
                    required     : true,
                    defaultValue : 1000,
                },
                [FieldDimensionId.Diagonal2]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 10,
                    range        : { min: 300, max: 3000 },
                    required     : true,
                    defaultValue : 1000,
                },
                [FieldDimensionId.Height3]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 10,
                    range        : { min: 300, max: 2500 },
                    required     : true,
                    defaultValue : 500,
                },
                [FieldDimensionId.Width4]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 10,
                    range        : { min: 300, max: 2500 },
                    required     : true,
                    defaultValue : 500,
                },
                [FieldDimensionId.Height5]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 10,
                    range        : { min: 800, max: 3000 },
                    required     : true,
                    defaultValue : 2000,
                },
            },
            [WindowShapeId.WindowTrapezoidalWithShell]: {
                [FieldDimensionId.Width1]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 10,
                    range        : { min: 300, max: 3000 },
                    required     : true,
                    defaultValue : 1000,
                },
                [FieldDimensionId.Diagonal2]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 10,
                    range        : { min: 300, max: 3000 },
                    required     : true,
                    defaultValue : 1000,
                },
                [FieldDimensionId.Height3]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 10,
                    range        : { min: 300, max: 2500 },
                    required     : true,
                    defaultValue : 500,
                },
                [FieldDimensionId.Width4]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 10,
                    range        : { min: 300, max: 2500 },
                    required     : true,
                    defaultValue : 500,
                },
                [FieldDimensionId.Height5]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 10,
                    range        : { min: 800, max: 3000 },
                    required     : true,
                    defaultValue : 2000,
                },
            },
            [WindowShapeId.WindowTriangle]: {
                [FieldDimensionId.Width1]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 10,
                    range        : { min: 300, max: 3000 },
                    required     : true,
                    defaultValue : 1000,
                },
                [FieldDimensionId.Width2]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 10,
                    range        : { min: 300, max: 3000 },
                    required     : true,
                    defaultValue : 1000,
                },
                [FieldDimensionId.Width3]: {
                    value        : undefined,
                    type         : IFormInputType.Range,
                    unit         : IDimensionUnit.Centimeters,
                    step         : 10,
                    range        : { min: 300, max: 3000 },
                    required     : true,
                    defaultValue : 1000,
                },
            },
        },
    },
};

export const fieldsWindowMaterial: IFormFieldMaterial = {
    material: {
        value   : undefined,
        options : getMaterialsWithExceptions(
            [
                ...allSolidWoods,
                ...allPlastics,
                ...allMetals,
            ],
            [
                MaterialId.Beech,
                MaterialId.WagonfloorDark,
                MaterialId.WagonfloorLight,
                MaterialId.OakOld,
                MaterialId.Walnut,
                MaterialId.Ash,
                MaterialId.AshOlive,
                MaterialId.Chestnut,
                MaterialId.Acacia,
                MaterialId.Mahogany,
                MaterialId.Elm,
                MaterialId.Alderwood,
                MaterialId.Birch,
                MaterialId.Maple,
                MaterialId.Teak,
                MaterialId.Wenge,
                MaterialId.Cherrywood,
                MaterialId.Ebony,
                MaterialId.Rubber,
                MaterialId.DriftWood,
                MaterialId.Poplar,
                MaterialId.Ipe,
                MaterialId.Padouk,
                MaterialId.Iroko,
                MaterialId.BlackLocust,
                MaterialId.Garapa,
                MaterialId.PlexiglassFluorescent,
                MaterialId.PlexiglassFrosted,
                MaterialId.PlexiglassMirror,
                MaterialId.PlexiglassTransparent,
                MaterialId.PlexiglassWhite,
                MaterialId.PolycarbonateOpaque,
                MaterialId.PolycarbonateTeinted,
                MaterialId.PolycarbonateTransparent,
                MaterialId.RecycledPlastic,
                MaterialId.Steel,
                MaterialId.Rust,
                MaterialId.Brass,
                MaterialId.Iron,
                MaterialId.ThermoLaqueredBlack,
                MaterialId.ThermoLaqueredWhite,
                MaterialId.SheetMetal,
                MaterialId.StainlessSteel,
                MaterialId.Zinc,
                MaterialId.WroughtIron,
            ],
        ),
        required: true,
    },
};

export const fieldsWindowLeaf: IFormFieldShape = {
    value   : undefined,
    options : [
        WindowLeafShapeId.WindowOneLeaf,
        WindowLeafShapeId.WindowTwoLeaf,
        WindowLeafShapeId.WindowThreeLeaf,
    ],
    required: true,
};

export const fieldsWindowOpening: IFormFieldRadioList = {
    value   : undefined,
    options : [
        WindowOpeningSideId.WindowOpeningRight,
        WindowOpeningSideId.WindowOpeningLeft,
        WindowOpeningSideId.WindowOpeningCasement,
        WindowOpeningSideId.WindowOpeningSliding,
        WindowOpeningSideId.WindowOpeningFrench,
        WindowOpeningSideId.WindowOpeningSwingTilting,
        WindowOpeningSideId.WindowOpeningToggle,
        WindowOpeningSideId.WindowOpeningNone,
    ],
    required: true,
};

export const fieldsWindowGlazing: IFormFieldRadioList = {
    value   : undefined,
    options : [
        WindowGlazingId.WindowSingleGlazing,
        WindowGlazingId.WindowDoubleGlazing,
        WindowGlazingId.WindowTripleGlazing,
        WindowGlazingId.WindowSoundproofGlazing,
        WindowGlazingId.WindowSafetyGlazing,
    ],
    required: true,
};

export const fieldsWindowInsulation: IFormFieldRadioList = {
    value   : undefined,
    options : [
        WindowInsulationId.WindowStandardInsulation,
        WindowInsulationId.WindowEfficientInsulation,
        WindowInsulationId.WindowUltraEfficientInsulation,
    ],
    required: true,
};
